export default __webpack_public_path__ + "static/media/Reader's Gloves of the Heavens.c6829863.jpg";